module.exports = __webpack_public_path__ + "img/bg3.fd93e469.png";